import { DateRange } from '@factorialco/f0-react/dist/experimental'
import moment from 'moment'

import { DatasourceType } from 'modules/ai_reports/components/DatasourceTypeRenderer/types'
import { datasourceTypeFromId } from 'modules/ai_reports/components/DatasourceTypeRenderer/utils'

import SnapshotTable from './tableRenderers/SnapshotTable'
import TraceabilityTable from './tableRenderers/TraceabilityTable'

export type DateNavigatorConfig = {
  defaultValue: DateRange | Date
  granularity: 'range' | 'day'
  max?: Date
}

type TableRenderer = {
  renderer: typeof SnapshotTable | typeof TraceabilityTable
  dateNavigatorConfig?: ({
    snapshotDate,
    dateRange,
  }: {
    snapshotDate?: Date
    dateRange?: DateRange
  }) => DateNavigatorConfig
}

const tableRendererRegistry: Record<DatasourceType, TableRenderer> = {
  snapshot: {
    renderer: SnapshotTable,
    dateNavigatorConfig: ({ snapshotDate } = { snapshotDate: undefined }): DateNavigatorConfig => {
      const now = new Date()
      return {
        defaultValue: snapshotDate ? new Date(snapshotDate) : now,
        granularity: 'day',
        max: now,
      }
    },
  },
  traceability: {
    renderer: TraceabilityTable,
    dateNavigatorConfig: ({ dateRange } = { dateRange: undefined }): DateNavigatorConfig => {
      const today = moment().startOf('day').toDate()
      return {
        defaultValue:
          dateRange && dateRange.from && dateRange.to
            ? { from: new Date(dateRange.from), to: new Date(dateRange.to) }
            : { from: today, to: today },
        granularity: 'range' as const,
        max: today,
      }
    },
  },
} as const

export const getRendererDef = (datasourceType: DatasourceType) => {
  const def = tableRendererRegistry[datasourceType]

  if (!def) {
    throw new Error(`Unknown datasource type: ${datasourceType}`)
  }
  return tableRendererRegistry[datasourceType]
}

export const getRenderedDefFromTableId = (tableId: string) => {
  const datasourceType = datasourceTypeFromId(tableId)
  return getRendererDef(datasourceType)
}
